import {memo, useMemo} from 'react'

import {stringifyId} from '../../../../../../types'
import RowGroup from '../../../../../common/Grid/RowGroup'
import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'
import {getVcsRoot, getVcsRootInstance} from '../../../../../packages/Changes/Changes.selectors'
import {VcsRootGroup} from '../ChangesRevisions.types'

import type {Props} from './ChangesRepository.types'
import ChangesRevision from './ChangesRevision'

import styles from './ChangesRepository.css'

import {useAppSelector} from 'src/hooks/react-redux'

function ChangesRepository({buildId, personal, revisionIds, vcsRootInstanceId, vcsGroup}: Props) {
  const vcsRootId = useAppSelector(
    state => getVcsRootInstance(state, vcsRootInstanceId)?.['vcs-root'],
  )
  const vcsRoot = useAppSelector(state => getVcsRoot(state, vcsRootId))
  const renderGroupIcon = useMemo(
    () =>
      vcsGroup != null ? (
        <SvgIcon
          className={styles.vcsGroupIcon}
          icon={vcsGroup === VcsRootGroup.SETTINGS ? 'filters' : 'link'}
          title={
            vcsGroup === VcsRootGroup.SETTINGS
              ? 'Settings revision'
              : 'Attached to snapshot dependency'
          }
        />
      ) : null,
    [vcsGroup],
  )
  return (
    <RowGroup>
      <div data-test-changes-repository className={styles.row}>
        <div className={styles.vcsRootColumn}>
          {renderGroupIcon}
          <span className={styles.vcsNameAndVcsRootName}>
            <span data-test-changes-repository-vcs-name className={styles.vcsName}>
              {'('}
              {vcsRoot?.vcsName || 'No vcs name'}
              {')'}
            </span>
            {vcsRoot?.name != null && (
              <span
                data-test-changes-repository-vcs-root-name
                className={styles.vcsRootName}
              >{`\u00a0${vcsRoot.name}`}</span>
            )}
          </span>
        </div>
        <div className={styles.revisionsColumn}>
          {revisionIds != null &&
            revisionIds.length > 0 &&
            revisionIds.map(revisionId => (
              <ChangesRevision
                key={stringifyId(revisionId)}
                buildId={buildId}
                vcsRootInstanceId={vcsRootInstanceId}
                revisionId={revisionId}
                personal={personal}
              />
            ))}
        </div>
      </div>
    </RowGroup>
  )
}

export default memo<Props>(ChangesRepository)
